<template>

    <form
        class="filters"
        @submit="filtrerAction"
    >
        <div class="filter filter-intervenant" v-if="$compte.intervenants_visibilite">
            <select
                class="form-control"
                v-if="actions.indexOf('intervenant') > -1"
                v-model="intervenant"
            >
                <option :value="null">Sélectionnez</option>
                <option v-for="inter in intervenants"
                        :key="inter.id"
                        :value="inter.id">{{inter.lib}}
                </option>
            </select>
        </div>
        <div class="filters_factures_libres" v-if="facturesIndependantes">
            <label
                    class="checkbox"
            >
                <input
                        type="checkbox"
                        v-model="facture_libre"
                />
                <div class="checkmark"></div>
                <span>inclure factures indépendantes</span>
            </label>
        </div>
        <div class="filter-dates">
            <div class="filter">
                <datepicker
                    input-class="form-control"
                    v-model="dateDebut"
                    format="DD/MM/YYYY"
                    :typeable="true"
                ></datepicker>
            </div>
            <div class="filter">
                <datepicker
                    input-class="form-control"
                    v-model="dateFin"
                    format="DD/MM/YYYY"
                    :typeable="true"
                ></datepicker>
            </div>
        </div>
        <div class="actions">
            <button
                class="btn btn-primary"
                type="submit"
            >Filtrer
            </button>
            <button
                class="btn btn-default btn-exporter"
                v-if="actions.indexOf('export') > -1"
                @click="exporter"
            >
                <i class="fas fa-download"></i> Exporter
            </button>
        </div>
        <div class="chargement" v-if="chargement">
            <div>
                <b> Chargement en cours... </b>
            </div>
        </div>
    </form>

</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import dayjs from 'dayjs';
  import api from '@/api'
  import saveAs from 'file-saver'

  export default {
    name: 'Filters',
    components: {
      Datepicker
    },
    props: {
      filtrer: Function,
      api: String,
      actions: Array,
      pagination: Boolean,
      defaultData: Object,
      facturesIndependantes: Boolean
    },
    data() {
      return {
        chargement: false,
        dateDebut: dayjs().startOf('year').toDate(),
        dateFin: dayjs().endOf('year').toDate(),
        intervenants: [],
        intervenant: null,
        facture_libre: false
      }
    },
    created() {
      const {intervenant, dateDebut, dateFin, facture_libre} = this.defaultData || {}
      this.intervenant = intervenant || this.intervenant
      this.dateDebut = dateDebut || this.dateDebut
      this.dateFin = dateFin || this.dateFin
        this.facture_libre = facture_libre || this.facture_libre
      if (this.actions.indexOf('intervenant') > -1) {
        api.intervenantsCharger().then(d => {
          this.intervenants = d.data
        })
      }
    },
    methods: {
      filtrerAction(e) {
        e.preventDefault()
        this.chargement = true

        const defaultParams = this.pagination ? {page: 1} : {}
        api[this.api]({
          ...defaultParams,
          ...this.formatQS()
        }).then(d => {
          const data = (d.data instanceof Array) ? {data: d.data} : {...d.data}
          this.filtrer({
            ...data,
            ...this.formatQS()
          })

          this.chargement = false
        })
      },
      exporter() {
        this.chargement = true

        api[this.api]({
          ...this.formatQS(),
          csv: true
        }).then(d => {
          const blob = new Blob([d.data], {type: "text/csv;charset=utf-8"});
          saveAs(blob, "export.csv");

          this.chargement = false
        })
      },
      formatQS() {
        return {
          intervenant: this.intervenant,
          facture_libre: this.facture_libre,
          debut: dayjs(this.dateDebut).format('YYYY-MM-DD'),
          fin: dayjs(this.dateFin).format('YYYY-MM-DD'),
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

    .filters {
        display: flex;

        @media only screen and (max-width: 768px){
            flex-wrap: wrap;
            width: 100%;
            margin: 0;
        }
    }

    .actions {
        display: flex;


        @media only screen and (max-width: 768px){
            width: 100%;
        }

        .btn {
            height: 38px !important;

            @media only screen and (max-width: 768px){
                width: 100%;
                max-width: inherit !important;
            }
        }
    }

    .filter-dates {
        display: flex;
        @media only screen and (max-width: 768px){
            width: 100%;
            margin-bottom: 10px;
        }

        .filter {
            margin-right: 10px;

            @media only screen and (max-width: 768px){
                width: 50%;
                margin: 0;
            }
        }
    }

    .filter-intervenant {
        margin-right: 10px;
        
        @media only screen and (max-width: 768px){
            width: 100%;
        }
    }

    .btn-exporter {
        margin-left: 10px;
    }

    .filters_factures_libres {
        margin-right: 1%;
        margin-bottom: 15px;
        width: 200px;
        color: #105BFB;
        text-transform: lowercase !important;
    }
</style>

<style>
   .vdp-datepicker__calendar {
        position: fixed !important;
    }
</style>
